export default "__VITE_ASSET__BjX6BPCs__"